import "./TopMenu.scss";

import { AppBar, IconButton, Toolbar, Typography } from "@mui/material";
import {
  ChatBubble as ChatBubbleIcon,
  ExpandMore as ExpandMoreIcon,
  Menu as MenuIcon
} from "@mui/icons-material";
import {
  handleNewChat,
  setBot,
  setBotsMenuOpen,
  setDrawerOpen
} from "../redux/chatSlice";
import { useDispatch, useSelector } from "react-redux";

import React from "react";
import { botChanged } from "../segment/Events";
import { bots } from "../utils/Bots";
import { getActiveSession } from "../utils/Functions";

function TopMenu() {
  const dispatch = useDispatch();
  const drawerOpen = useSelector((state) => state.chat.drawerOpen);
  const botsMenuOpen = useSelector((state) => state.chat.botsMenuOpen);
  const activeBot = useSelector((state) => state.chat.bot);
  const chatSessions = useSelector((state) => state.chat.chatSessions);
  const activeSession = useSelector((state) => state.chat.activeSession);

  let activeSessionMessages = getActiveSession(
    chatSessions,
    activeSession
  ).messages;

  return (
    <AppBar
      className="top-menu"
      position="sticky"
      sx={{ backgroundColor: "#f5f5f5", color: "#000000" }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <IconButton
          color="inherit"
          className="top-menuIcon"
          onClick={() => {
            dispatch(setDrawerOpen(!drawerOpen));
            dispatch(setBotsMenuOpen(false));
          }}
        >
          <MenuIcon sx={{ color: "#047dff" }} />
        </IconButton>
        <div
          className="top-menu-title"
          onClick={() => dispatch(setBotsMenuOpen(!botsMenuOpen))}
        >
          <img
            className="top-menu-logo"
            src={activeBot.logo}
            alt="Ask Mother Nature AI Logo"
          />
          <Typography variant="h6" className="top-menu-title-text">
            {activeBot.name}
          </Typography>
          <IconButton
            className="top-menu-expand"
            color="inherit"
            size="small"
            onClick={() => dispatch(setBotsMenuOpen(!botsMenuOpen))}
          >
            <ExpandMoreIcon sx={{ fontSize: "2rem" }} />
          </IconButton>
        </div>
        <IconButton
          className="top-chatIcon"
          color="inherit"
          onClick={() => {
            dispatch(handleNewChat());
            dispatch(setBotsMenuOpen(false));
          }}
        >
          <ChatBubbleIcon sx={{ color: "#047dff" }} />
        </IconButton>
      </Toolbar>
      {botsMenuOpen && (
        <div className="top-bots">
          {Object.entries(bots)
            .filter(([bot]) => bot !== activeBot.id)
            .map(([botId, bot]) => (
              <div
                className="top-bot"
                onClick={() => {
                  dispatch(setBot(bots[botId]));
                  dispatch(setBotsMenuOpen(false));
                  botChanged(bot[botId]);
                  if (activeSessionMessages.length !== 0) {
                    dispatch(handleNewChat());
                  }
                }}
              >
                <div className="top-botDivider" />
                <img
                  className="top-botLogo"
                  src={bot.logo}
                  alt={`${bot.name}`}
                />
                <Typography variant="h6" className="top-botName">
                  {bot.name}
                </Typography>
                <div className="top-botDescription">{bot.menuDescription}</div>
              </div>
            ))}
        </div>
      )}
    </AppBar>
  );
}

export default TopMenu;
